import React, { useState, useEffect } from 'react';
import './AddPurchase.css';
import axios from "axios";
import { useParams } from "react-router-dom";

const AddStaffSalary = () => {
  const { user_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [formData, setFormData] = useState({
    user_id: user_id,
    actual: "0.00",
    total_days: "0",
    lop: "0",
    working_days: "0",
    hra_per: "0",
    hra_amt: "0.00",
    epf_per: "0",
    epf_amt: "0.00",
    savings_per: "0",
    savings_amt: "0.00",
    iste_per: "0",
    iste_amt: "0.00",
    gross: "0.00",
    basic: "0.00",
    others: "0.00",
    deduction: "0.00",
    net_salary: "0.00",

    name: "",
    designation: "",
    department: "",
    doj: "",
  });

  const getDaysInCurrentMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  };


  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_detail.php`, { user_id: user_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setFormData(response.data.body);
          setFormData(prev => ({
            ...prev,            // keep all your default fields
            ...response.data.body // overwrite only fields that API provides
          }));

          // setFilteredOrders(response.data.body);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setFormData([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setFormData([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  useEffect(() => {
    const days = getDaysInCurrentMonth();

    setFormData(prev => ({
      ...prev,
      total_days: days
    }));

    const total = Number(formData.total_days) || 0;
    const lop = Number(formData.lop) || 0;

    const working = total - lop;
    // console.log("working==============", formData.totalDays);
    setFormData(prev => ({
      ...prev,
      working_days: working >= 0 ? working : 0
    }));


  }, [formData.total_days, formData.lop]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };



  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    // if (!formData.designation) newErrors.designation = "Designation is required";
    // if (!formData.department) newErrors.department = "Department is required";
    // if (!formData.doj) newErrors.doj = "Date of joining is required";
    if (!formData.actual) newErrors.actual = "Actual salary is required";
    // Add more validations as needed
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log("validationErrors", validationErrors);
    } else {
      setErrors({});
      console.log("Submitted:", formData);
      // Submit to backend here

      axios.post(`${API_BASE_URL}salary_sf_add.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setDepartmentList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.history.back();

          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setDepartmentList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }
  };

  const renderError = (field) =>
    errors[field] && <small className="text-danger">{errors[field]}</small>;

  useEffect(() => {
    setFormData((prev) => {
      const actual = Number(prev.actual) || 0;
      const totalDays = Number(prev.total_days) || 1;
      const lop = Number(prev.lop) || 0;

      // Gross = actual – (lop * perDaySalary)
      const perDay = actual / totalDays;
      const lopAmt = perDay * lop;
      const gross = actual - lopAmt;

      // HRA
      const hra_per = Number(prev.hra_per) || 0;
      const hra_amt = (gross * hra_per) / 100;

      // Basic = Gross – HRA
      const basic = gross - hra_amt;

      // Savings
      const savings_per = Number(prev.savings_per) || 0;
      const savings_amt = (basic * savings_per) / 100;

      // EPF
      const epf_per = Number(prev.epf_per) || 0;
      const epf_amt = (basic * epf_per) / 100;

      // ISTE
      const iste_per = Number(prev.iste_per) || 0;
      const iste_amt = (actual * iste_per) / 100;

      const others = Number(prev.others) || 0;

      // Total Deduction
      const totalDeduction = savings_amt + epf_amt;

      // Net Salary
      const netSalary = gross - totalDeduction;

      return {
        ...prev,
        gross: gross.toFixed(2),
        hra_amt: hra_amt.toFixed(2),
        basic: basic.toFixed(2),
        savings_amt: savings_amt.toFixed(2),
        epf_amt: epf_amt.toFixed(2),
        iste_amt: iste_amt.toFixed(2),
        others: others.toFixed(2),
        deduction: totalDeduction.toFixed(2),
        net_salary: netSalary.toFixed(2),
      };
    });
  }, [
    formData.actual,
    formData.total_days,
    formData.lop,
    formData.hra_per,
    formData.savings_per,
    formData.epf_per,
    formData.iste_per,
    formData.others
  ]);



  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Staff Salary</h4>
        <button className="btn-top" onClick={() => window.history.back()}>Back</button>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="row g-3">
          {[
            { label: "Name", name: "name", value: formData.name, read: true },
            { label: "Designation", name: "designation", value: formData.desig_name, read: true },
            { label: "Department", name: "department", value: formData.depart_name, read: true },
            { label: "Date of Joining", name: "doj", placeholder: "dd-mm-yyyy", value: formData.date_of_join, read: true },
            { label: "Actual Salary", name: "actual", value: formData.basic_salary, read: true },
            { label: "Total Days", name: "total_days", value: formData.total_days, read: true },
            { label: "LoP", name: "lop", value: formData.lop, read: true },
            { label: "Working Days", name: "working_days", value: formData.working_days, read: true },
            { label: "HRA %", name: "hra_per" },
            { label: "EPF %", name: "epf_per" },
            { label: "Savings %", name: "savings_per" },
            { label: "ISTE %", name: "iste_per" },
            { label: "Gross", name: "gross", value: formData.gross, read: true },
            { label: "Basic", name: "basic", value: formData.basic, read: true },
            { label: "HRA", name: "hra_amt", value: formData.hra_amt, read: true },
            { label: "ISTE", name: "iste_amt", value: formData.iste_amt, read: true },
            { label: "EPF", name: "epf_amt", value: formData.epf_amt, read: true },
            { label: "Savings", name: "savings_amt", value: formData.savings_amt, read: true },
            { label: "Others", name: "others" },
            { label: "Total Deduction", name: "deduction", value: formData.deduction, read: true },
            { label: "Net Salary", name: "net_salary", value: formData.net_salary, read: true },
          ].map(({ label, name, placeholder, value, read }) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
              <label className="form-label">{label}</label>
              <input
                type="text"
                className="form-control"
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
                readOnly={read ? true : false}
              />
              {renderError(name)}
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button type="submit" className="btn-submit">Submit</button>
          <button type="button" className="btn-cancel" onClick={() => window.history.back()}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AddStaffSalary;
